import { BaseLineFreeCrop } from '@/app/components/icons/BaseLineFreeCrop';
import RectIcon from '@/app/components/shared/RectIcon';
import type { CropOption } from '../use-crop-options';

interface CropOptionDisplayProps {
  option: CropOption;
}

export const CropOptionDisplay = ({ option }: CropOptionDisplayProps) => {
  return (
    <>
      <div>{typeof option.value === 'number' ? <RectIcon ratio={option.value} /> : <BaseLineFreeCrop />}</div>
      <span className="font-medium text-sm">{option.label}</span>
    </>
  );
};
